import SettingOutlined from '@ant-design/icons/SettingOutlined';
import NavItem from './Navigation/NavItem';

export default function NavSettings() {
  const settingsItem = {
    id: 'settings',
    title: 'Settings',
    type: 'item',
    icon: SettingOutlined,
    url: '/restaurant/settings',
    breadcrumbs: false
  };

  return <NavItem item={settingsItem} level={1} />;
}
